export enum ReproductionStatusCode {
  Gestation = 'gestation',
  Lactation = 'lactation',
  None = 'none',
}
